import { dictionaries } from "@/dictionaries/content";

import { SelectedDataType } from "../map-panel-context";

import { CLUSTER_SELECTION_TITLE } from "./components/cluster-selection/cluster-selection.constants";

export function getDetailsPanelTitle(type: SelectedDataType | undefined): string {
  if (!type) {
    return "";
  }

  switch (type) {
    case SelectedDataType.STUDENT:
      return "Student Information";
    case SelectedDataType.SCHOOL:
      return "School Information";
    case SelectedDataType.SELECTION:
      return "Selection Information";
    case SelectedDataType.STUDENT_CLUSTER:
      return "Selection Information";
    case SelectedDataType.SCHOOL_CLUSTER:
    case SelectedDataType.PROJECT_CLUSTER:
    case SelectedDataType.ZONES:
      return CLUSTER_SELECTION_TITLE;
    case SelectedDataType.PROJECT:
      return "Project Info";
    case SelectedDataType.BOUNDARY:
      return dictionaries.mapPage?.boundaryPanel?.title ?? "Boundary";
    case SelectedDataType.SEARCH_MARKER:
      return dictionaries.mapPage?.searchMarker?.title ?? "Address info";
    default:
      return "";
  }
}
